/* eslint-disable jsx-a11y/media-has-caption */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import objectPath from 'object-path';
import styled from 'styled-components';
import { rem, cover } from 'polished';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';
import PlayButton from '../../play-button';
import Waves from '../../waves';
import { YTModalContext } from '../../with-youtube-modal';

export default class Hero extends PureComponent {

  static propTypes = {
    leftHeading: PropTypes.string,
    rightHeading: PropTypes.string,
    modalVideo: PropTypes.string,
    heroImage: PropTypes.object,
    playHomeVideo: PropTypes.bool,
  }

  constructor(props) {
    super(props);

    this.hero = React.createRef();
  }

  componentDidMount() {
    const titles = this.hero.current.querySelectorAll('span');
    const titleText1 = new SplitText(titles[0], { type: 'words,chars' });
    const titleText2 = new SplitText(titles[1], { type: 'words,chars' });
    const playButton = this.hero.current.querySelector('.hero-play-button');

    this.videos = this.hero.current.querySelectorAll('video');
    const staticBG = this.hero.current.querySelector('.static-background');
    const allPaths = this.hero.current.querySelectorAll('.wave_svg__wave-path');
    const videoCheck = this.videos.length > 0;

    this.postVideoTL = new TimelineMax({
      paused: true,
      onComplete: () => {
        titleText1.revert();
        titleText2.revert();
      },
    });

    this.videoFadeInTL = new TimelineMax({
      paused: true,
    });

    if (videoCheck) {
      this.videoFadeInTL
        .to(this.videos, 0.2, { opacity: 1 });
    }

    if (videoCheck) {
      this.postVideoTL
        .to(this.videos, 0.2, { opacity: 0 });
    }

    this.postVideoTL
      .set(titles, { opacity: 1 })
      .add('fade', 0.5)
      .staggerFrom(allPaths, 0.2, { opacity: 0, ease: Power3.easeIn, stagger: -0.07 }, null, 'fade')
      .staggerTo(allPaths, 2.2, { strokeDashoffset: 0, ease: Power2.easeIn, stagger: -0.07 }, null, 'fade')
      .staggerFrom(titleText1.chars, 0.7, { opacity: 0, scale: 0.5, x: -10, y: 30, rotationX: -180, transformOrigin: '0% 50% -20', ease: Back.easeOut.config(1.8), stagger: 0.04 }, null, 'fade');

    if (playButton) {
      this.postVideoTL
        .to(playButton, 0.1, { opacity: 1, scale: 1, ease: Power3.easeOut }, 'fade+=0.6');
    }

    this.postVideoTL
      .staggerFrom(titleText2.chars, 0.7, { opacity: 0, scale: 0.5, x: -10, y: 30, rotationX: -180, transformOrigin: '0% 50% -20', ease: Back.easeOut.config(1.8), stagger: 0.04 }, null, 'fade+=0.6')
      .to(staticBG, 2, { opacity: 1, ease: Power3.easeOut }, 'fade+=.2');

    if (this.props.playHomeVideo === false) {
      this.postVideoTL.play(0);
    } else if (videoCheck) {
      this.videos[0].oncanplay = this.startVideos();
    }

    if (!videoCheck) {
      this.postVideoTL.play(0.6, false);
    }
  }

  startVideos = () => {
    this.videos[0].play();
    this.videoFadeInTL.play();

  }

  videoFadeIn = () => {
    this.videoFadeInTL.play();
  }

  postVideos = () => {
    this.postVideoTL.play(0.6, false);
  }

  componentWillUnmount() {
    this.postVideoTL.kill();
    this.videoFadeInTL.kill();
  }

  render() {

    const { heroImage } = this.props;

    return (
      <StyledHero ref={this.hero}>

        <Content>
          <HeroH2>
            <span className="title title-1">{this.props.leftHeading}</span>
            <span className="title title-2">{this.props.rightHeading}</span>
          </HeroH2>

          {this.props.modalVideo &&
            <YTModalContext.Consumer>
              {context => (
                <HeroPlay
                  className="hero-play-button"
                  onClick={(e) => { context.toggleModal(e, this.props.modalVideo); }}
                  aria-label="Open video modal"
                />
              )}
            </YTModalContext.Consumer>
          }

        </Content>

        <VideoWrap>

          <HeroStaticBG className="static-background">
            {objectPath.has(heroImage, 'fields.file.url') &&
              <picture>
                <source
                  srcSet={`${heroImage.fields.file.url}?w=1920&h=920&q=80&fit=fill&fm=webp`}
                  media="(min-width: 1681px)"
                  type="image/webp"
                />
                <source
                  srcSet={`${heroImage.fields.file.url}?w=1920&h=920&q=80&fit=fill&fm=jpg&fl=progressive`}
                  media="(min-width: 1681px)"
                  type="image/jpeg"
                />
                <source
                  srcSet={`${heroImage.fields.file.url}?w=3360&h=1890&q=80&fit=fill&fm=webp 2x, ${heroImage.fields.file.url}?w=1680&h=945&q=80&fit=fill&fm=webp 1x`}
                  media="(min-width: 600px)"
                  type="image/webp"
                />
                <source
                  srcSet={`${heroImage.fields.file.url}?w=3360&h=1890&q=80&fit=fill&fm=jpg&fl=progressive 2x, ${heroImage.fields.file.url}?w=1680&h=945&q=80&fit=fill&fm=jpg&fl=progressive 1x`}
                  media="(min-width: 600px)"
                  type="image/jpeg"
                />
                <source
                  srcSet={`${heroImage.fields.file.url}?w=750&h=678&q=75&fit=fill&fm=webp 2x, ${heroImage.fields.file.url}?w=375&h=339&q=75&fit=fill&fm=webp 1x`}
                  type="image/webp"
                />
                <source
                  srcSet={`${heroImage.fields.file.url}?w=750&h=354&q=75&fit=fill&fm=jpg&fl=progressive 2x, ${heroImage.fields.file.url}?w=375&h=339&q=75&fit=fill&fm=jpg&fl=progressive 1x`}
                  type="image/jpeg"
                />
                <img src={`${heroImage.fields.file.url}?w=1920&h=920&q=80&fit=fill&fm=jpg&fl=progressive`} alt={heroImage.fields.description} />
              </picture>
            }
          </HeroStaticBG>

        </VideoWrap>

        <Waves position="bottom" alignment="bottom" animateReady height={350} />
      </StyledHero>
    );
  }
}

const StyledHero = styled.section`
  position: relative;
  height: ${(9 / 16) * 100}vw;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${screen.below(bp.mobileSm, `
    height: calc(76vw + 54px);
  `)}
`;

const Content = styled.div`
  position: relative;
  margin-bottom: 40px;
  z-index: 2;

  ${screen.below(bp.desktop, `
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `)}
`;

const HeroH2 = styled.h2`
  color: #fff;
  text-align: center;


  .title-1 {
    margin-bottom: 10px;
  }

  .title {
    font-kerning: none;
    display: block;
    padding: 0 20px;
    opacity: 0;
  }

  ${screen.below(bp.mobileSm, `
    font-size: ${rem(32)}

    .title {
      padding: 0 8px;
    }
  `)};
`;

const VideoWrap = styled.div`
  ${cover()}
  z-index: 0;
  background-color: #000;
`;

const HeroStaticBG = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.black};
  opacity: 0;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    opacity: .7;
  }

`;

const HeroPlay = styled(PlayButton)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  opacity: 0;
  transform: scale(.1);
  transform-origin: 50% 50%;

  ${screen.below(bp.desktop, `
    height: 80px;
    width: 80px;
  `)}
  ${screen.below(bp.mobile, `
    height: 40px;
    width: 40px;
  `)}
`;
